import * as types from './mutation-types'

export default {
    [types.LOAD_MODERATORS](state, data) {
      state.moderators = data.participators
    },
  
    [types.LOAD_PRESENTATORS](state, data) {
        state.presentators = data.participators
    },

    [types.LOAD_ATELIER_PROGRAMS](state, data) {
      state.programs = data
    },

    [types.LOAD_PLANNINGS](state, data) {
      state.plannings = data.programs
    },

    [types.LOAD_PROGRAM_ENUMS](state, data) {
      state.programEnums = data
    },

    [types.LOAD_ATELIER_TYPE_ENUMS](state, data) {
      state.atelierTypes = data
    },

    [types.SET_CURRENT_PLANNING](state, data) {
        state.currentPlanning = data
    },
}
